import get from "lodash/get";

export const getOverlayStatus = (state, overlayId) =>
  get(state, `overlays.${overlayId}`, false);
